(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["karnikaa-slideshow"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('[data-karnikaa-slideshow]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const s=[...root.querySelectorAll('.karnikaa-slideshow__slide')],d=[...root.querySelectorAll('.dots button')];let i=0,t;const go=n=>{i=(n+s.length)%s.length;s.forEach((x,j)=>x.classList.toggle('is-active',j===i));d.forEach((x,j)=>x.classList.toggle('active',j===i))};root.addEventListener('click',e=>{const b=e.target.closest('[data-action]');if(!b)return;if(b.dataset.action==='next')go(i+1);if(b.dataset.action==='previous')go(i-1);if(b.dataset.action==='go')go(+b.dataset.index)});if(root.dataset.autoplay==='true'&&s.length>1)t=setInterval(()=>go(i+1),+root.dataset.speed*1000)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
